import type { IDashboardItem, IDashboardData } from '@/types'
import { defineStore } from "pinia";

interface IDashboardStore {
  data: IDashboardData | undefined
  isClubParticipationActivated: boolean
  isLoading: boolean
}

interface IActivateClubResult {
  isActivated: boolean
  errorMessage: string
}

export const useDashboardStore = defineStore({
  id: 'dashboard',
  state: (): IDashboardStore => ({
    data: undefined,
    isClubParticipationActivated: false,
    isLoading: false,
  }),
  getters: {},
  actions: {
    async loadDashboardData() {
      if (this.data) return

      const response = await this.axiosFactory
        .withoutToken()
        .get(`/api/Participation/GetDashboardData`)

      if (response.data?.success) {
        this.data = response.data.data
      } else {
        console.log('Navigation API Response:', response)
      }
    },
    async updateDashboardData(data: IDashboardData) {
      if (this.isLoading) return;
      this.isLoading = true;
      try {
        const response = await this.axiosFactory
          .withoutToken()
          .post(`/api/Participation/UpdateDashboardData`, data)
        if (response.data?.success) {
          if (this.data) {
            this.data = response.data.data
          }
        } else {
          console.log('Navigation API Response:', response)
        }
      } finally {
        this.isLoading = false;
      }
    },
    async isClubActivated() {
      const response = await this.axiosFactory
        .withoutToken()
        .get(`/api/Participation/IsClubActivated`)
      if (response.data?.success) {
        this.isClubParticipationActivated = response.data.data as boolean
        return this.isClubParticipationActivated;
      } else {
        console.log('Navigation API Response:', response)
        return false
      }
    },
    async activateClub(): Promise<IActivateClubResult> {
      const response = await this.axiosFactory
        .withoutToken()
        .post(`/api/Participation/ActivateClub`)

      if (response.data?.success) {
        this.isClubParticipationActivated = response.data.data as boolean
        return {
          isActivated: this.isClubParticipationActivated,
          errorMessage: ''
        }
      }

      console.log('Navigation API Response:', response)
      return {
        isActivated: false,
        errorMessage: response.data?.errorMessage ?? 'Unable to activate Participation at this time.'
      }
    }
  }
})
